import IconBase from './IconBase';

const ChevronLeft = (props) => (
  <IconBase {...props}>
    <polyline points="15 18 9 12 15 6" />
  </IconBase>
);

export default ChevronLeft;
